import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  TemplateRef,
} from '@angular/core';
import { LoginStorage } from './../../../../login/login.storage';
import { DadoSimulacaoSeguro } from './../model/dado-simulacao-seguro';
import { GrupoSeguro } from '../model/proposta/grupo-seguro';
import { GrupoAssistencia } from '../model/proposta/grupo-assistencia';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GrupoSeguroSelecionado } from '../model/proposta/grupo-seguro-selecionado';
import { GrupoAssistenciaSelecionado } from '../model/proposta/grupo-assistencia-selecionado';
import { CustomModalService } from '../../../../shared/modais/custom-modal/custom-modal.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'seguro',
  templateUrl: './seguro.component.html',
  styleUrls: ['./seguro.component.scss'],
})
export class SeguroComponent implements OnInit, OnChanges {
  @Input() retornoMax: number;
  @Input() retorno: number;
  @Input() proposta: string;
  @Input() grupoSeguroIds: GrupoSeguroSelecionado[] = [];
  @Input() grupoAssistenciaIds: GrupoAssistenciaSelecionado[] = [];
  @Input() gruposSeguros: GrupoSeguro[] = [];
  @Input() gruposAssistencias: GrupoAssistencia[] = [];
  @Input() tipoVeiculo: string;
  @Input() indexGarantia?: number;
  @Input() isVeiculoPrincipal?: boolean = false;
  @Output() seguroSelected: EventEmitter<DadoSimulacaoSeguro> =
    new EventEmitter();

  gruposAssistenciasPorTipo: GrupoAssistencia[] = [];

  private retornoAnterior: number;
  private grupoSeguroIdsAnterior: GrupoSeguroSelecionado[];
  private grupoAssistenciaIdsAnterior: GrupoAssistenciaSelecionado[];
  public isLojista = false;
  private grupoSeguroSelecionado: GrupoSeguroSelecionado[] = [];
  private grupoAssistenciaSelecionado: GrupoAssistenciaSelecionado[] = [];
  private modalRef: BsModalRef;

  isBackgroundBlue: boolean = true;

  public readonly GRUPO_ID_SEGURO_ROUBO_FURTO = 32;

  constructor(
    private readonly loginStorage: LoginStorage,
    private readonly modalService: CustomModalService
  ) {}

  ngOnInit() {
    this.isLojista = this.loginStorage.usuario.isLojista;
  }

  ngOnChanges() {
    this.retornoAnterior = this.retorno;
    this.grupoSeguroIdsAnterior = this.grupoSeguroIds;
    this.grupoAssistenciaIdsAnterior = this.grupoAssistenciaIds;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-md',
      keyboard: false,
      ignoreBackdropClick: true,
    });
    this.grupoSeguroSelecionado = this.grupoSeguroIds;
    this.grupoAssistenciaSelecionado = this.grupoAssistenciaIds;

    this.gruposAssistenciasPorTipo = cloneDeep(this.gruposAssistencias);

    if (!this.isVeiculoPrincipal) {
      this.gruposAssistenciasPorTipo = this.gruposAssistenciasPorTipo.filter(
        (grupoAssistencia) => {
          return grupoAssistencia.nivel === 'GARANTIA';
        }
      );
    }

    this.gruposAssistenciasPorTipo.map((grupoAssistencia) => {
      grupoAssistencia.assistencias = grupoAssistencia.assistencias.filter(
        (assistencia) => assistencia.tipo === this.tipoVeiculo
      );
    });
  }

  onSelectionSeguro(id: number, grupoId: number) {
    const seguro = new GrupoSeguroSelecionado(id, grupoId);
    this.grupoSeguroSelecionado = this.grupoSeguroSelecionado.filter(
      (x) => x.grupoId !== grupoId
    ); // remove todos do grupo
    this.grupoSeguroSelecionado.push(seguro);
  }

  onSelectionAssistencia(id: number, grupoId: number) {
    const assist = new GrupoAssistenciaSelecionado(id, grupoId);
    this.grupoAssistenciaSelecionado = this.grupoAssistenciaSelecionado.filter(
      (x) => x.grupoId !== grupoId
    ); // remove todos do grupo
    this.grupoAssistenciaSelecionado.push(assist);
  }

  onClickClose() {
    this.retorno = this.retornoAnterior;
    this.grupoSeguroIds = this.grupoSeguroIdsAnterior;
    this.grupoAssistenciaIds = this.grupoAssistenciaIdsAnterior;

    this.modalRef.hide();
  }

  onClickCloseClear() {
    this.onSaveClick();
    this.onClickClose();
  }

  onSaveClick() {
    if (
      this.retorno !== this.retornoAnterior ||
      this.grupoSeguroSelecionado.length > 0 ||
      this.grupoAssistenciaSelecionado.length > 0
    ) {
      const seguro = new DadoSimulacaoSeguro();
      seguro.setRetorno(this.retorno);
      if (this.grupoSeguroSelecionado.length > 0) {
        seguro.setGrupoSeguroIds(this.grupoSeguroSelecionado);
      }
      if (this.grupoAssistenciaSelecionado.length > 0) {
        seguro.setGrupoAssistenciaIds(
          this.grupoAssistenciaSelecionado.map((g) => ({
            ...g,
            tipoVeiculo: this.tipoVeiculo,
          })),
          this.indexGarantia
        );
      }
      this.seguroSelected.emit(seguro);
    }

    this.modalRef.hide();
  }

  hasGrupoSeguro() {
    return this.gruposSeguros || this.gruposSeguros.length > 0;
  }

  hasGrupoAssistencia() {
    return (
      this.gruposAssistenciasPorTipo ||
      this.gruposAssistenciasPorTipo.length > 0
    );
  }

  checkAssistenciaNone(idGrupo: number): boolean {
    const assistencias = this.gruposAssistenciasPorTipo.find(
      (o) => o.id === idGrupo
    ).assistencias;
    let intersection;

    if (this.grupoAssistenciaIds) {
      intersection = assistencias.filter((element) =>
        this.grupoAssistenciaIds.some((x) => x.assistenciaId === element.id)
      );
    }

    return intersection && intersection.length === 0;
  }

  checkSeguroNone(idGrupo: number): boolean {
    const seguros = this.gruposSeguros.find((o) => o.id === idGrupo).seguros;
    const intersection = seguros.filter((element) =>
      this.grupoSeguroIds.some((x) => x.seguroId === element.id)
    );

    return intersection.length === 0;
  }

  checkSeguro(seguroId: number): boolean {
    return this.grupoSeguroIds
      ? this.grupoSeguroIds.some((x) => x.seguroId === seguroId)
      : false;
  }

  checkAssistencia(assistenciaId: number): boolean {
    if (this.grupoAssistenciaIds) {
      return this.grupoAssistenciaIds
        ? this.grupoAssistenciaIds.some(
            (x) => x.assistenciaId === assistenciaId
          )
        : false;
    }
  }

  hasRouboFurto() {
    return this.gruposSeguros.some(
      (grupo) => grupo.id === this.GRUPO_ID_SEGURO_ROUBO_FURTO
    );
  }

  filterRouboFurto() {
    return this.isLojista
      ? this.gruposSeguros.filter(
          (grupo) => grupo.id === this.GRUPO_ID_SEGURO_ROUBO_FURTO
        )
      : this.gruposSeguros;
  }

  isRouboFurto(grupoId: number) {
    return grupoId === this.GRUPO_ID_SEGURO_ROUBO_FURTO;
  }
}
